/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { PageInfoDto } from '../models/page-info-dto';
import { portfolioAdminControllerCreateV1 } from '../fn/portfolio-admin/portfolio-admin-controller-create-v-1';
import { PortfolioAdminControllerCreateV1$Params } from '../fn/portfolio-admin/portfolio-admin-controller-create-v-1';
import { portfolioAdminControllerDeleteV1 } from '../fn/portfolio-admin/portfolio-admin-controller-delete-v-1';
import { PortfolioAdminControllerDeleteV1$Params } from '../fn/portfolio-admin/portfolio-admin-controller-delete-v-1';
import { portfolioAdminControllerFindAllV1 } from '../fn/portfolio-admin/portfolio-admin-controller-find-all-v-1';
import { PortfolioAdminControllerFindAllV1$Params } from '../fn/portfolio-admin/portfolio-admin-controller-find-all-v-1';
import { portfolioAdminControllerFindByIdV1 } from '../fn/portfolio-admin/portfolio-admin-controller-find-by-id-v-1';
import { PortfolioAdminControllerFindByIdV1$Params } from '../fn/portfolio-admin/portfolio-admin-controller-find-by-id-v-1';
import { portfolioAdminControllerReorderV1 } from '../fn/portfolio-admin/portfolio-admin-controller-reorder-v-1';
import { PortfolioAdminControllerReorderV1$Params } from '../fn/portfolio-admin/portfolio-admin-controller-reorder-v-1';
import { portfolioAdminControllerSearchCursorV1 } from '../fn/portfolio-admin/portfolio-admin-controller-search-cursor-v-1';
import { PortfolioAdminControllerSearchCursorV1$Params } from '../fn/portfolio-admin/portfolio-admin-controller-search-cursor-v-1';
import { portfolioAdminControllerSearchOffsetV1 } from '../fn/portfolio-admin/portfolio-admin-controller-search-offset-v-1';
import { PortfolioAdminControllerSearchOffsetV1$Params } from '../fn/portfolio-admin/portfolio-admin-controller-search-offset-v-1';
import { portfolioAdminControllerUpdateV1 } from '../fn/portfolio-admin/portfolio-admin-controller-update-v-1';
import { PortfolioAdminControllerUpdateV1$Params } from '../fn/portfolio-admin/portfolio-admin-controller-update-v-1';
import { PortfolioDto } from '../models/portfolio-dto';

@Injectable({ providedIn: 'root' })
export class PortfolioAdminService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `portfolioAdminControllerFindAllV1()` */
  static readonly PortfolioAdminControllerFindAllV1Path = '/api/v1/portfolios/admin';

  /**
   * Get all portfolios.
   *
   * Get all portfolios for admin.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `portfolioAdminControllerFindAllV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  portfolioAdminControllerFindAllV1$Response(params?: PortfolioAdminControllerFindAllV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PortfolioDto>>> {
    const obs = portfolioAdminControllerFindAllV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get all portfolios.
   *
   * Get all portfolios for admin.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `portfolioAdminControllerFindAllV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  portfolioAdminControllerFindAllV1(params?: PortfolioAdminControllerFindAllV1$Params, context?: HttpContext): Observable<Array<PortfolioDto>> {
    const resp = this.portfolioAdminControllerFindAllV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<PortfolioDto>>): Array<PortfolioDto> => r.body)
    );
  }

  /** Path part for operation `portfolioAdminControllerCreateV1()` */
  static readonly PortfolioAdminControllerCreateV1Path = '/api/v1/portfolios/admin';

  /**
   * Create portfolio.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `portfolioAdminControllerCreateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  portfolioAdminControllerCreateV1$Response(params: PortfolioAdminControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<PortfolioDto>> {
    const obs = portfolioAdminControllerCreateV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create portfolio.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `portfolioAdminControllerCreateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  portfolioAdminControllerCreateV1(params: PortfolioAdminControllerCreateV1$Params, context?: HttpContext): Observable<PortfolioDto> {
    const resp = this.portfolioAdminControllerCreateV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PortfolioDto>): PortfolioDto => r.body)
    );
  }

  /** Path part for operation `portfolioAdminControllerSearchOffsetV1()` */
  static readonly PortfolioAdminControllerSearchOffsetV1Path = '/api/v1/portfolios/admin/search/offset';

  /**
   * Search portfolios by offset pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `portfolioAdminControllerSearchOffsetV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  portfolioAdminControllerSearchOffsetV1$Response(params: PortfolioAdminControllerSearchOffsetV1$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<PortfolioDto>;
'pageInfo': PageInfoDto;
}>> {
    const obs = portfolioAdminControllerSearchOffsetV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Search portfolios by offset pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `portfolioAdminControllerSearchOffsetV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  portfolioAdminControllerSearchOffsetV1(params: PortfolioAdminControllerSearchOffsetV1$Params, context?: HttpContext): Observable<{
'items': Array<PortfolioDto>;
'pageInfo': PageInfoDto;
}> {
    const resp = this.portfolioAdminControllerSearchOffsetV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'items': Array<PortfolioDto>;
'pageInfo': PageInfoDto;
}>): {
'items': Array<PortfolioDto>;
'pageInfo': PageInfoDto;
} => r.body)
    );
  }

  /** Path part for operation `portfolioAdminControllerSearchCursorV1()` */
  static readonly PortfolioAdminControllerSearchCursorV1Path = '/api/v1/portfolios/admin/search/cursor';

  /**
   * Search portfolios by cursor pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `portfolioAdminControllerSearchCursorV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  portfolioAdminControllerSearchCursorV1$Response(params: PortfolioAdminControllerSearchCursorV1$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<PortfolioDto>;

/**
 * 다음 페이지의 커서 값
 */
'nextCursor'?: string | null;

/**
 * 다음 페이지 존재 여부
 */
'hasNext': boolean;
}>> {
    const obs = portfolioAdminControllerSearchCursorV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Search portfolios by cursor pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `portfolioAdminControllerSearchCursorV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  portfolioAdminControllerSearchCursorV1(params: PortfolioAdminControllerSearchCursorV1$Params, context?: HttpContext): Observable<{
'items': Array<PortfolioDto>;

/**
 * 다음 페이지의 커서 값
 */
'nextCursor'?: string | null;

/**
 * 다음 페이지 존재 여부
 */
'hasNext': boolean;
}> {
    const resp = this.portfolioAdminControllerSearchCursorV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'items': Array<PortfolioDto>;

/**
 * 다음 페이지의 커서 값
 */
'nextCursor'?: string | null;

/**
 * 다음 페이지 존재 여부
 */
'hasNext': boolean;
}>): {
'items': Array<PortfolioDto>;

/**
 * 다음 페이지의 커서 값
 */
'nextCursor'?: string | null;

/**
 * 다음 페이지 존재 여부
 */
'hasNext': boolean;
} => r.body)
    );
  }

  /** Path part for operation `portfolioAdminControllerFindByIdV1()` */
  static readonly PortfolioAdminControllerFindByIdV1Path = '/api/v1/portfolios/admin/{id}';

  /**
   * Get portfolio detail.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `portfolioAdminControllerFindByIdV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  portfolioAdminControllerFindByIdV1$Response(params: PortfolioAdminControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<PortfolioDto>> {
    const obs = portfolioAdminControllerFindByIdV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get portfolio detail.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `portfolioAdminControllerFindByIdV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  portfolioAdminControllerFindByIdV1(params: PortfolioAdminControllerFindByIdV1$Params, context?: HttpContext): Observable<PortfolioDto> {
    const resp = this.portfolioAdminControllerFindByIdV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PortfolioDto>): PortfolioDto => r.body)
    );
  }

  /** Path part for operation `portfolioAdminControllerDeleteV1()` */
  static readonly PortfolioAdminControllerDeleteV1Path = '/api/v1/portfolios/admin/{id}';

  /**
   * Delete portfolio.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `portfolioAdminControllerDeleteV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  portfolioAdminControllerDeleteV1$Response(params: PortfolioAdminControllerDeleteV1$Params, context?: HttpContext): Observable<StrictHttpResponse<PortfolioDto>> {
    const obs = portfolioAdminControllerDeleteV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete portfolio.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `portfolioAdminControllerDeleteV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  portfolioAdminControllerDeleteV1(params: PortfolioAdminControllerDeleteV1$Params, context?: HttpContext): Observable<PortfolioDto> {
    const resp = this.portfolioAdminControllerDeleteV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PortfolioDto>): PortfolioDto => r.body)
    );
  }

  /** Path part for operation `portfolioAdminControllerUpdateV1()` */
  static readonly PortfolioAdminControllerUpdateV1Path = '/api/v1/portfolios/admin/{id}';

  /**
   * Update portfolio.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `portfolioAdminControllerUpdateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  portfolioAdminControllerUpdateV1$Response(params: PortfolioAdminControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<PortfolioDto>> {
    const obs = portfolioAdminControllerUpdateV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update portfolio.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `portfolioAdminControllerUpdateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  portfolioAdminControllerUpdateV1(params: PortfolioAdminControllerUpdateV1$Params, context?: HttpContext): Observable<PortfolioDto> {
    const resp = this.portfolioAdminControllerUpdateV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PortfolioDto>): PortfolioDto => r.body)
    );
  }

  /** Path part for operation `portfolioAdminControllerReorderV1()` */
  static readonly PortfolioAdminControllerReorderV1Path = '/api/v1/portfolios/admin/reorder';

  /**
   * Reorder portfolios.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `portfolioAdminControllerReorderV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  portfolioAdminControllerReorderV1$Response(params: PortfolioAdminControllerReorderV1$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = portfolioAdminControllerReorderV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Reorder portfolios.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `portfolioAdminControllerReorderV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  portfolioAdminControllerReorderV1(params: PortfolioAdminControllerReorderV1$Params, context?: HttpContext): Observable<void> {
    const resp = this.portfolioAdminControllerReorderV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
